module.exports = __webpack_public_path__ + "static/media/hexaMint.bdda75ff.svg";